import { defineStore } from 'pinia'

export const useXeroStore = defineStore({
    id: 'xero',
    state: () => ({
        accounts: null,
        transactions: null,
        xeroAccountMappings: null,
        brandingThemes: null,
        feedConnection: null,
        bankDetailsPanel: [],
    }),
    actions: {
        async fetchTransactions(fromDate, toDate) {
            this.transactions = await this.$nuxt.$axios.$get(`api/transaction?fromDate=${fromDate}&toDate=${toDate}`)
        },
        async fetchAccounts() {
            const xeroAccounts = await this.$nuxt.$axios.$get('api/xero/accounts')

            this.accounts = xeroAccounts.map(x => {
                if (x.code === x.name) {
                    return { ...x }
                }
                return { ...x, name: `${x.name} ${x.code != null ? '- ' + x.code : ''}` }
            })
        },
        async loadAccountMappings() {
            this.xeroAccountMappings = await this.$nuxt.$axios.$get('/api/xero-account-mapping')
        },
        async fetchBrandingThemes() {
            this.brandingThemes = await this.$nuxt.$axios.$get('api/xero/branding-themes')
        },
        async fetchFeedConnection() {
            this.feedConnection = await this.$nuxt.$axios.$get('/api/xero/feed-connection')
        },
        updateFeedConnection(feedConnection) {
            this.feedConnection = feedConnection
        },
        updateBankDetailsPanel(index) {
            this.bankDetailsPanel = [index]
        },
    },
    getters: {},
})
